import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { usePostOrPatchPaymentDetails } from '../usePostOrPatchPaymentDetails';
export function useBankDetailsModal(props) {
    const { t } = useTranslation();
    const { postOrPatchPaymentDetails, paymentDetails: paymentDetailsPostOrPatchPaymentDetails, error: errorPostOrPatchPaymentDetails, loading: loadingPostOrPatchPaymentDetails, setError: setErrorPostOrPatchPaymentDetails, } = usePostOrPatchPaymentDetails();
    const [showAlert, setShowAlert] = useState(undefined);
    const { onClose, onSave, selectedKeyType, keyValue, accountType, agencyNumber, accountNumber, selectedInstitution, paymentDetails, accountPayable, } = props;
    useEffect(() => {
        if (paymentDetailsPostOrPatchPaymentDetails &&
            !loadingPostOrPatchPaymentDetails &&
            !errorPostOrPatchPaymentDetails) {
            setShowAlert({
                message: t('modal-bank-details-success-message'),
                appearance: 'success',
            });
            onSave && onSave(paymentDetailsPostOrPatchPaymentDetails);
        }
    }, [paymentDetailsPostOrPatchPaymentDetails, loadingPostOrPatchPaymentDetails, errorPostOrPatchPaymentDetails]);
    useEffect(() => {
        if (!loadingPostOrPatchPaymentDetails && errorPostOrPatchPaymentDetails) {
            setShowAlert({
                message: errorPostOrPatchPaymentDetails,
                appearance: 'error',
            });
        }
    }, [loadingPostOrPatchPaymentDetails, errorPostOrPatchPaymentDetails]);
    useEffect(() => {
        if (showAlert === undefined) {
            setErrorPostOrPatchPaymentDetails(undefined);
        }
    }, [showAlert, setErrorPostOrPatchPaymentDetails]);
    const closeModal = useCallback(() => {
        onClose && onClose();
    }, [onClose]);
    const onSaveValue = useCallback(() => {
        const postOrPatchPaymentDetailsBody = {
            keyType: selectedKeyType,
            pixKey: keyValue,
            id: paymentDetails?.id,
            document: paymentDetails?.documentNumber ?? accountPayable?.employeeDetails?.documentNumber,
            documentType: paymentDetails?.documentType ?? accountPayable?.employeeDetails?.documentType,
            accountType: accountType,
            financialInstitutionCode: selectedInstitution?.code,
            agencyNumber: agencyNumber,
            accountNumber: accountNumber?.replace(/\D/g, ''),
            party: paymentDetails?.party ?? accountPayable?.party,
        };
        postOrPatchPaymentDetails(postOrPatchPaymentDetailsBody);
    }, [
        postOrPatchPaymentDetails,
        selectedKeyType,
        keyValue,
        accountType,
        agencyNumber,
        accountNumber,
        selectedInstitution,
        paymentDetails,
        accountPayable,
    ]);
    return {
        closeModal,
        onSaveValue,
        error: errorPostOrPatchPaymentDetails,
        loading: loadingPostOrPatchPaymentDetails,
        showAlert,
        setShowAlert,
        setErrorPostOrPatchPaymentDetails,
    };
}
